import type { GetThirdPartyMessagesResponseBody } from '@common/interfaces/api/thirdPartyMessagesApi';
import { fetchJson } from '@frontend/store/fetch';

export async function getThirdPartyMessagesForProcess(
    processId: string,
    signal: AbortSignal
): Promise<GetThirdPartyMessagesResponseBody> {
    const url = `/api/processes/${processId}/thirdPartyMessages`;
    const result = await fetchJson({ method: 'GET', signal, url });

    return result.json;
}
